// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseShiftsCreationAreaRoutes = {
  route: '/shifts-creation',
}

export const ShiftsCreationAreaRoutes = transformRoutes(
  BaseShiftsCreationAreaRoutes,
)
